module.exports = __webpack_public_path__ + "img/vodafone.5938e8e9.png";